import axios from "axios";

const login = async (data) => {
  const url = `/v1/login`;
  return axios.post(url, data, { baseURL: process.env.REACT_APP_API_URL });
};

export { login };
